export default {
  moneySymbol: 'SEK',
  deleteThisLine: 'Radera denna rad',
  copyThisLine: 'Kopiera denna rad',
  form: {
    lightFilter: {
      more: 'Fler filter',
      clear: 'Rensa',
      confirm: 'Bekräfta',
      itemUnit: 'objekt'
    }
  },
  tableForm: {
    search: 'Sök',
    reset: 'Återställ',
    submit: 'Skicka',
    collapsed: 'Expandera',
    expand: 'Fäll ihop',
    inputPlaceholder: 'Vänligen ange',
    selectPlaceholder: 'Vänligen välj'
  },
  alert: {
    clear: 'Avbryt val',
    selected: 'Vald',
    item: 'objekt'
  },
  pagination: {
    total: {
      range: 'Från',
      total: 'objekt/totalt',
      item: 'objekt'
    }
  },
  tableToolBar: {
    leftPin: 'Fäst till vänster',
    rightPin: 'Fäst till höger',
    noPin: 'Inte fäst',
    leftFixedTitle: 'Fäst till vänster',
    rightFixedTitle: 'Fäst till höger',
    noFixedTitle: 'Inte fäst',
    reset: 'Återställ',
    columnDisplay: 'Kolumnvisning',
    columnSetting: 'Kolumninställningar',
    fullScreen: 'Fullskärm',
    exitFullScreen: 'Avsluta fullskärm',
    reload: 'Ladda om',
    density: 'Täthet',
    densityDefault: 'Normal',
    densityLarger: 'Lös',
    densityMiddle: 'Medium',
    densitySmall: 'Kompakt'
  },
  stepsForm: {
    next: 'Nästa steg',
    prev: 'Föregående steg',
    submit: 'Skicka'
  },
  loginForm: {
    submitText: 'Logga in'
  },
  editableTable: {
    onlyOneLineEditor: 'Endast en rad kan redigeras åt gången',
    action: {
      save: 'Spara',
      cancel: 'Avbryt',
      delete: 'Radera',
      add: 'Lägg till en rad'
    }
  },
  switch: {
    open: 'Öppna',
    close: 'Stäng'
  }
};